import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {BatchDetails, initialBatchDetails} from '../../interfaces/batch'

const batchDetailsSlice = createSlice({
  name: 'batchDetailsSlice',
  initialState: initialBatchDetails,
  reducers: {
    setCurrentBatchDetails: (state, action: PayloadAction<BatchDetails>) => {
      state.batchId = action.payload.batchId
      state.invalidRecords = action.payload.invalidRecords
      state.payableAmount = action.payload.payableAmount
      state.totalAmount = action.payload.totalAmount
      state.totalRecords = action.payload.totalRecords
      state.validRecords = action.payload.validRecords
      state.notificationEmail = action.payload.notificationEmail
    },
    deleteCurrentBatchDetails: () => initialBatchDetails
  },
})

export const {setCurrentBatchDetails, deleteCurrentBatchDetails} = batchDetailsSlice.actions

export default batchDetailsSlice.reducer
